import { Skeleton } from 'antd';
import { Column } from 'farmhub-ui-core';

import { theme } from 'styled';

const TitleElectronicBillSkeleton = () => (
  <Column alignItems="center" styles={{ gap: theme.spacing.xs }}>
    <Skeleton.Input size="small" style={{ width: 250 }} />
    <Skeleton.Input size="small" style={{ width: 180 }} />
  </Column>
);

export default TitleElectronicBillSkeleton;
